
// frontend/src/components/Header.tsx
import React from 'react';
import logo from '../images/logo.png'; // Logo importu ekleyelim

interface HeaderProps {
  user: any;
  onSignIn: () => Promise<void>;
  onSignOut: () => Promise<void>;
  className?: string;
}

export const Header: React.FC<HeaderProps> = ({ 
  user, 
  onSignIn, 
  onSignOut,
  className = "" 
}) => {
  return (
    <header className={`px-6 py-4 ${className}`}>
      <div className="container mx-auto flex justify-between items-center">
        <div className="flex items-center space-x-4">
          <a href="/" className="flex items-center hover:text-blue-400 transition-colors">
            <img 
              src={logo} 
              alt="İmba Logo" 
              className="h-8 w-auto mr-2" // Yüksekliği sabit tutup genişliği oransal ayarladık
            />
            <h1 className="text-xl font-bold text-white">imba DMARC Analyzer</h1>
          </a>
        </div>
        
        <div className="flex items-center space-x-4">
          {user ? (
            <div className="flex items-center space-x-4">
              <div className="flex items-center">
                {user.photoURL && (
                  <img 
                    src={user.photoURL} 
                    alt={user.displayName || ''} 
                    className="h-8 w-8 rounded-full mr-2"
                  />
                )}
                <span className="text-sm text-white">{user.displayName}</span>
              </div>
              <button 
                onClick={onSignOut}
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-md text-sm transition-colors"
              >
                Çıkış Yap
              </button>
            </div>
          ) : (
            <button 
              onClick={onSignIn}
              className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-md text-sm transition-colors"
            >
              Google ile Giriş Yap
            </button>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;